import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "tableCornerRadius bg-white" }
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "cursor-pointer rowHeight" }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "cursor-pointer rowHeight" }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_27 = ["value", "disabled"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "table-ellipsis" }
const _hoisted_34 = ["onMousemove"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "title" }, "Risk Clone", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cloneRisk())),
          class: _normalizeClass((JSON.stringify(_ctx.defaultSelectedIds) == JSON.stringify(_ctx.selectedTierObjectIds)) ? 'btndisabled pointer-events-none':'btnprimary')
        }, " Clone ", 2),
        _createElementVNode("button", {
          class: "filterButton flex",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "filterIcon"
          }, null, -1),
          _createTextVNode(" Filters ")
        ]))
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mt-3 text-sm" }, " The Global Risks Report 2022, 17th Edition, is published by the World Economic Forum. The information in this report, or on which this report is based, has been obtained from sources that the authors believe to be reliable and accurate. However, it has not been independently verified and no representation or warranty, express or implied, is made as to the accuracy or completeness of any information obtained from third parties. ", -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _cache[7] || (_cache[7] = _createElementVNode("th", { class: "w-1/12" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headersData, (column) => {
              return (_openBlock(), _createElementBlock("th", {
                scope: "col",
                onClick: ($event: any) => (_ctx.sort(column)),
                key: column,
                class: "bg-white capitalize w-1/2"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center", {'w-28':column == 'entityType'}])
                }, [
                  _createElementVNode("div", null, _toDisplayString(column), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                  }, null, 2)
                ], 2)
              ], 8, _hoisted_7))
            }), 128)),
            (_ctx.showFilters)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("td", { class: "w-4" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headersData, (name, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "bg-white",
                      key: index
                    }, [
                      (name == 'entityType')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            class: "inputboxStylingForFilter filter-font-size w-28",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.filtersObject[name]) = $event)
                          }, [
                            _createElementVNode("option", {
                              value: _ctx.filtersObject.name,
                              disabled: "",
                              selected: "",
                              hidden: ""
                            }, "Select", 8, _hoisted_10),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgType, (value, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: index,
                                value: value.id
                              }, _toDisplayString(value.value), 9, _hoisted_11))
                            }), 128))
                          ], 8, _hoisted_9)), [
                            [_vModelSelect, _ctx.filtersObject[name]]
                          ])
                        : (name == 'criticality')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 1,
                              class: "inputboxStylingForFilter",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.filtersObject[name]) = $event)
                            }, [
                              _createElementVNode("option", {
                                value: _ctx.filtersObject.name,
                                selected: "",
                                hidden: "",
                                disabled: ""
                              }, "Select", 8, _hoisted_13),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbProcessCriticality, (pair) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: pair,
                                  value: pair.value
                                }, _toDisplayString(pair.key), 9, _hoisted_14))
                              }), 128))
                            ], 8, _hoisted_12)), [
                              [_vModelSelect, _ctx.filtersObject[name]]
                            ])
                          : (name === 'securityCategory')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 2,
                                class: "inputboxStylingForFilter widthForSelect",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filtersObject[name]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filtersObject.name,
                                  disabled: "",
                                  selected: "",
                                  hidden: ""
                                }, "Select", 8, _hoisted_16),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (pair) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: pair,
                                    value: pair.value
                                  }, _toDisplayString(pair.key), 9, _hoisted_17))
                                }), 128))
                              ], 8, _hoisted_15)), [
                                [_vModelSelect, _ctx.filtersObject[name]]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 3,
                                type: "text",
                                class: "inputboxStylingForFilter filter-font-size w-full",
                                placeholder: "Search",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filtersObject[name]) = $event)
                              }, null, 8, _hoisted_18)), [
                                [_vModelText, _ctx.filtersObject[name]]
                              ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.dataLoading == true)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                _createElementVNode("tr", _hoisted_20, [
                  _createElementVNode("td", {
                    class: "relative h-5",
                    colspan: _ctx.headersData.length
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_dots_loader)
                    ])
                  ], 8, _hoisted_21)
                ])
              ]))
            : (_ctx.sortedData.length==0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                  _createElementVNode("tr", _hoisted_24, [
                    _createElementVNode("td", {
                      class: "relative h-10",
                      colspan: _ctx.headersData.length + 1
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("div", { class: "flex justify-center" }, [
                        _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                      ], -1)
                    ]), 8, _hoisted_25)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (tierObj, indexx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: tierObj,
                      class: "cursor-pointer rowHeight"
                    }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "checkbox ml-4",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTierObjectIds) = $event)),
                          value: tierObj._id,
                          disabled: _ctx.defaultSelectedIds.includes(tierObj._id)
                        }, null, 8, _hoisted_27), [
                          [_vModelCheckbox, _ctx.selectedTierObjectIds]
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headersData, (column) => {
                        return (_openBlock(), _createElementBlock("td", {
                          onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doFalse())),
                          key: column,
                          class: "cursor-pointer relative"
                        }, [
                          (column == 'entityType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.getOwnerType(tierObj[column])), 1)
                              ]))
                            : (column == 'criticality' || column == 'securityCategory')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorRiskBg(tierObj[column])])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.colorRiskText(tierObj[column]))
                                    }, [
                                      (column =='criticality')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.dbProcessCriticality.find((l) => {
                                                    return l.value == tierObj[column];
                                                }).key), 1))
                                        : (column == 'securityCategory' )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.getSecurityCategory(tierObj[column])), 1))
                                          : _createCommentVNode("", true)
                                    ], 2)
                                  ], 2)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", {
                                      onMousemove: ($event: any) => (_ctx.toolTip(column, $event, indexx, tierObj, 'text'))
                                    }, _toDisplayString(tierObj[column]), 41, _hoisted_34)
                                  ])
                                ]))
                        ], 32))
                      }), 128))
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      (_ctx.sortedData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createVNode(_component_pagination, {
              dynamicPagination: _ctx.dynamicPagination,
              onCurrentPageUpdate: _ctx.paginationUpdations,
              sortedData: _ctx.sortedData
            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.toolTipActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
        ]))
      : _createCommentVNode("", true)
  ]))
}